export const SUBMIT_PURCHASE_ON_SPOT_START = 'SUBMIT_PURCHASE_ON_SPOT_START';

export const SUBMIT_PURCHASE_ON_SPOT_SUCCESS = 'SUBMIT_PURCHASE_ON_SPOT_SUCCESS';

export const SUBMIT_PURCHASE_ON_SPOT_FAILED = 'SUBMIT_PURCHASE_ON_SPOT_FAILED';
